import React from 'react'
import { CrumplePopSignupContext } from '../contexts/CrumplePopSignupContext'

export default function CrumplePopAccountDetails({data}) {
    const [migrationState] = React.useContext(CrumplePopSignupContext);

    const pageCopy = React.useMemo(() => {
        const isTrial = migrationState.orderId == null;
        return getPageCopy(migrationState.page, isTrial);
    }, [migrationState.page, migrationState.orderId])

    if (!data) return <></>

    let address = <></>
    if (data.address){
        address = (
            <>
            <span>&nbsp;</span>
            <span>{data.address.street}
                <br/>{data.address.street2}
            </span>
            <span>{data.address.city}, {data.address.state} {data.address.zip}</span>
            <span>{data.address.country}</span>
            </>
        )
    }

    return (
        <div className='box cpop-account-details-container'>
            <div className='cpop-logo-container'>
                <img src='/svgs/suite-logo.svg' />
                <h4 className='cpop-logo-header'>Boris FX Hub</h4>
            </div>
            <div className='cpop-additional-copy'>
                <p>{pageCopy}</p>
            </div>
            <div className='cpop-account-info'>
                <div className='read-only-field'>
                    <label>Email</label>
                    <span>{data.email}</span>
                </div>
                <div className='read-only-field'>
                    <label>Account Details</label>
                    <span>{data.firstName} {data.lastName}</span>
                </div>
            </div>
        </div>
    )
}

const getPageCopy = (page, isTrial) => {
    switch(page){
        case 'signup':
            return 'To move your CrumplePop account to Boris FX, just fill out the fields below. You\'re already almost done!';
        case 'bfx-login':
            return 'To move your CrumplePop account to Boris FX, simply sign in to your existing Boris FX account below.';
        case 'subscription':
            return 'Please enter your payment information.  Your old account will be closed, so you won\'t be double-billed.';
        case 'download':
            if (isTrial){
                return 'Just one more step! Please don\'t skip this, because it\'s important. Download the Boris FX Hub app by clicking the “Download” button below. Then install it and launch it. The Hub app will automatically clean up any plugin conflicts, and you can use it to easily update and manage your CrumplePop plugins. It\'s very handy. Enjoy!';
            }
            else{
                return 'Just one more step! Please don\'t skip this, because it\'s important. Click the “Download” button below to download the Boris FX Hub app. Install the Boris FX Hub app, and then sign in to the app with your new Boris FX account. In the Hub, you can choose to start a trial for CrumplePop or enter an activation key. Please copy/paste your activation key below into the Boris FX Hub app to activate CrumplePop.';
            }
        default:
            return '';
    }
}